import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class DisplayGroupsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync() {
        const displayGroups = await this.httpClient.get<Mri.DisplayGroups.DisplayGroup[]>(`/api/v1/display-groups`);

        setMap(this.displayGroups, displayGroups, d => d.name);
    }

    @action
    public async loadAsync(name: string) {
        const displayGroup = await this.httpClient.get<Mri.DisplayGroups.DisplayGroup>(
            `/api/v1/display-groups/${name}`
        );

        if (displayGroup) this.displayGroups.set(displayGroup.name, displayGroup);
    }

    @action
    public async createAsync(model: Mri.DisplayGroups.DisplayGroup) {
        const displayGroup = await this.httpClient.post<Mri.DisplayGroups.DisplayGroup>(
            '/api/v1/display-groups',
            model
        );

        if (displayGroup) this.displayGroups.set(displayGroup.name, displayGroup);
    }

    @action
    public async deleteAsync(name: string) {
        await this.httpClient.delete(`/api/v1/display-groups/${name}`);

        this.displayGroups.delete(name);
    }

    @action
    public async updateAsync(name: string, model: Mri.DisplayGroups.DisplayGroup) {
        const updatedDisplay = await this.httpClient.put<Mri.DisplayGroups.DisplayGroup>(
            `/api/v1/display-groups/${name}`,
            model
        );

        if (updatedDisplay) this.displayGroups.set(updatedDisplay.name, updatedDisplay);
    }

    @action
    public async addDisplayAsync(
        name: string,
        model: Mri.Web.Internal.Controllers.Displays.DisplaySerialNumberListModel
    ) {
        const newDisplay = await this.httpClient.post<Mri.DisplayGroups.DisplayGroup>(
            `/api/v1/display-groups/${name}/displays`,
            model
        );

        if (newDisplay) this.displayGroups.set(newDisplay.name, newDisplay);
    }

    @action
    public async removeDisplayAsync(
        name: string,
        model: Mri.Web.Internal.Controllers.Displays.DisplaySerialNumberListModel
    ) {
        const newDisplay = await this.httpClient.put<Mri.DisplayGroups.DisplayGroup>(
            `/api/v1/display-groups/${name}/displays`,
            model
        );

        if (newDisplay) this.displayGroups.set(newDisplay.name, newDisplay);
    }

    @observable
    public displayGroups = new Map<string, Mri.DisplayGroups.DisplayGroup>();

    private readonly httpClient: HttpClient;
}
